import React from 'react';
import { Box } from '@warp-ds/react';

interface Props {
    totalClicks: number;
    squareMeterPrice: number;
}

export function Indicators({ totalClicks, squareMeterPrice }: Props) {
    const sqmString = squareMeterPrice !== 0 ? `${squareMeterPrice.toLocaleString('nb-no')} kr` : '(*)';
    return (
        <div className="mb-16 flex flex-col gap-x-12 gap-y-12 md:flex-row">
            <Box info className="flex flex-1 flex-col items-center">
                <span className="text-22 md:text-34 font-bold">{totalClicks.toLocaleString('nb-no')} klikk</span>
                <p>på annonsen</p>
            </Box>
            <Box info className="flex flex-1 flex-col items-center">
                <span className="text-22 md:text-34 font-bold">{sqmString}</span>
                <p>prisantydning per kvadratmeter</p>
            </Box>
        </div>
    );
}
